<template>
  <div class="content-box">
    <div class="element-wrapper">
      <div class="element-box">
        <h5 class="form-header">Pedidos Mayoreo</h5>
        <div class="controls-above-table">
          <div class="row">
            <div class="controls-above-table">
              <div class="row"></div>
            </div>
            <div>
              <NuevoPedidoModalComponent />
            </div>
            <div>
              <button @click="abrirModalFiltros()" class="btn btn-sm btn-success">
                Filtros <i class="fa fa-filter"></i>
              </button>
              <button @click="abrirModalPrecios()" class="btn btn-sm btn-success">
                Precios <i class="fas fa-comment-dollar"></i>
              </button>
            </div>
          </div>
        </div>

        <div class="table-responsive">
          <!-------------------- Tabla de Resultados -------------------->
          <table class="table table-hover">
            <thead>
              <tr>
                <th></th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="current in data.results"
                v-bind:key="current.id"
                @click="rowClick(current)"
              >
                <td>
                  <div class="value">
                    <span class="font-weight-bold"># {{ current.numero }}</span>
                  </div>
                  <span
                    ><div class="value">{{ current.fecha }}</div></span
                  >
                </td>
                <td>
                  <div class="value">
                    <small class="font-weight-bold">{{
                      current.cliente ? current.cliente.nombre : ""
                    }}</small>
                  </div>

                  <small
                    ><div class="value">
                      <div class="status-pill smaller green"></div>
                      &nbsp;{{ current.estado_str }}
                    </div></small
                  >
                </td>
              </tr>
            </tbody>
          </table>
          <!-------------------- END - Tabla de Resultados -------------------->
        </div>
        <PaginationComponent
          tipo="MINI"
          :currentPage="currentPage"
          :data="data"
          @pagechanged="onPageChange"
        />
      </div>
      <!-- modal de filtro -->

      <div
        class="modal fade"
        id="filtroModal"
        tabindex="-1"
        role="dialog"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div class="modal-dialog" role="document">
          <div class="modal-content modal-lg">
            <div class="modal-body">
              <div class="col-12">
                <div class="row">
                  <div class="col-10">
                    <h5 class="modal-title" id="exampleModalLabel">Filtros</h5>
                  </div>
                  <div class="col-2">
                    <button type="button" class="btn btn-link" data-dismiss="modal">
                      <i class="fas fa-times"></i>
                    </button>
                  </div>
                  <button
                    v-on:click="clearFilterData()"
                    type="button"
                    class="btn btn-link"
                  >
                    Refresh &nbsp; <i class="fa fa-sync"></i>
                  </button>
                </div>
                <div class="row">
                  <div class="col-12" style="padding: 3px">
                    <input
                      class="form-control form-control-sm rounded bright"
                      placeholder="Search"
                      v-model="searchtext"
                      type="text"
                    />
                  </div>
                  <div style="padding: 3px" class="col-12">
                    <input
                      class="form-control form-control-sm rounded bright"
                      placeholder="# Pedido"
                      v-model="search.numero"
                      type="text"
                    />
                  </div>
                  <div style="padding: 3px" class="col-12">
                    <input
                      class="form-control form-control-sm rounded bright"
                      placeholder="Nit cliente"
                      v-model="search.cliente"
                      type="text"
                    />
                  </div>
                  <div style="padding: 3px" class="col-12">
                    <select
                      class="form-control form-control-sm rounded bright"
                      v-model="filtro_tienda"
                      @change="refreshCajas()"
                    >
                      <option value="">Tiendas</option>
                      <option
                        v-for="data in tiendas"
                        :value="data.codigo"
                        v-bind:key="data.id"
                      >
                        {{ data.nombre }}
                      </option>
                    </select>
                  </div>
                  <div style="padding: 3px" class="col-12">
                    <input
                      type="date"
                      v-model="search.fecha"
                      class="form-control form-control-sm rounded bright"
                    />
                  </div>

                  <div style="padding: 3px" class="col-12">
                    <select
                      :disabled="!filtro_tienda"
                      class="form-control form-control-sm rounded bright"
                      v-model="filtro_caja"
                    >
                      <option value="">cajas</option>
                      <option v-for="data in cajas" :value="data.id" v-bind:key="data.id">
                        {{ data.caja }}
                      </option>
                    </select>
                  </div>

                  <div style="padding: 3px" class="col-12">
                    <select
                      class="form-control form-control-sm rounded bright"
                      v-model="filtro_estado"
                    >
                      <option value>ESTATUS</option>
                      <option value="9">ANULADO</option>
                      <option value="A">ABIERTO</option>
                      <option value="B">CERRADO</option>
                      <option value="E">IMPRESA</option>
                      <option value="I">PICKING</option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-success" v-on:click="filterData()">
                Buscar &nbsp; <i class="fa fa-search"></i>
              </button>

              <button data-dismiss="modal" type="button" class="btn btn-secondary">
                <i class="fa fa-times"></i>
              </button>
            </div>
          </div>
        </div>
      </div>

      <!-- fin de modal de filtros -->
      <!-- aqui inicia el modal de filtros -->
      <div
        class="modal fade"
        id="preciosModal"
        tabindex="-1"
        role="dialog"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div class="modal-dialog" role="document">
          <div class="modal-content modal-lg">
            <div class="modal-body">
              <div class="row">
                <div class="col-12">
                  <TiendaSelectComponent :current="current" />
                </div>
                <div class="col-12">
                  <ProductoSelectComponent :current="current" />
                </div>
                <div class="table">
                  <h6>Precios</h6>
                  <table class="table">
                    <thead>
                      <th></th>
                      <th></th>
                      <th></th>
                    </thead>
                    <tbody>
                      <tr v-for="item in precios" :key="item.id">
                        <td>{{ item.lista_precio.nombre }}</td>
                        <td>{{ item.unidad_medida.nombre }}</td>
                        <td>{{ item.precio }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button
                type="button"
                class="btn btn-success"
                v-on:click="consultarPrecios()"
              >
                Consultar &nbsp; <i class="fa fa-check"></i>
              </button>

              <button data-dismiss="modal" type="button" class="btn btn-secondary">
                <i class="fa fa-times"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import PaginationComponent from "@/components/utils/PaginationComponent";
import PedidosServices from "@/services/pos/PedidosServices";
import UsuarioEnTablaComponent from "@/components/commons/UsuarioEnTablaComponent";
import NuevoPedidoModalComponent from "@/components/pos/pos_mayoreo/NuevoPedidoModalComponent";
import DynamicService from "@/services/commons/DynamicService";
import ProductoSelectComponent from "@/components/commons/ProductoSelectComponent";
import TiendaSelectComponent from "@/components/commons/TiendaSelectComponent";

export default {
  components: {
    PaginationComponent,
    UsuarioEnTablaComponent,
    NuevoPedidoModalComponent,
    ProductoSelectComponent,
    TiendaSelectComponent,
  },
  data() {
    return {
      tiendas_user: [],
      mostrarRefresh: false,
      currentPage: 1,
      searchtext: "",
      filterActivo: "",
      data: [],
      search: {},
      filtro_tienda: "",
      tiendas: "",
      filtro_estado: "",
      filtro_caja: "",
      cajas: "",
      current: {},
      precios: [],
    };
  },
  mounted() {
    this.refreshData();
    this.refreshTienda();
  },
  methods: {
    consultarPrecios() {
      let self = this;
      if (!self.current.tienda) {
        alert("El campo de tienda es obligatorio");
        return;
      }
      DynamicService.getByIdParams("cat", "productos", self.current.producto.sku, {
        tienda: self.current.tienda,
      }).then((response) => {
        self.precios = response.data.lista_precios;
      });
    },
    convertFormatDate(search) {
      search.fecha_creacion = moment(search.fecha).format("DD/MM/YYYY");
    },
    abrirModalPrecios() {
      let self = this;
      $("#preciosModal").modal("show");
    },
    abrirModalFiltros() {
      let self = this;
      $("#filtroModal").modal("show");
    },
    refreshCajas() {
      let self = this;
      this.filtro_caja = "";
      DynamicService.fetch("cat", "precios", {
        tienda: this.filtro_tienda,
      }).then((response) => {
        self.cajas = response.data.results;
      });
    },
    refreshTienda() {
      let self = this;
      DynamicService.fetch("cat", "tiendas", {
        activa: true,
        quitar_paginacion: true,
      }).then((response) => {
        self.tiendas = response.data;
      });
    },
    rowClick(current) {
      let self = this;
      if (event.ctrlKey) {
        let routeUrl = this.$router.resolve({
          name: "pos-pedidos-mayoreo-ver",
          params: { id: current.id },
        });
        window.open(routeUrl.href, "_blank");
      } else {
        self.$router.push({
          name: "pos-pedidos-mayoreo-ver",
          params: { id: current.id },
        });
      }
    },
    onPageChange(page) {
      this.currentPage = page;
      this.refreshData({
        page: page,
        "filter[search]": this.$data.searchtext,
        estado: this.filtro_estado,
        tienda: this.filtro_tienda,
        caja: this.filtro_caja,
        cargo_serie: this.search.cargo_serie,
        cliente: this.search.cliente,
        numero: this.search.numero,
        fecha: this.search.fecha_creacion,
      });
    },
    filterData() {
      if (this.search.fecha) {
        this.convertFormatDate(this.search);
      }
      this.refreshData({
        page: this.$data.currentPage,
        "filter[search]": this.$data.searchtext,
        estado: this.filtro_estado,
        caja: this.filtro_caja,
        tienda: this.filtro_tienda,
        cargo_serie: this.search.cargo_serie,
        cliente: this.search.cliente,
        numero: this.search.numero,
        fecha: this.search.fecha_creacion,
      });
    },
    filterDataSubmit(e) {
      this.filterData();
      e.preventDefault();
    },
    clearFilterData() {
      this.filtro_tienda = "";
      this.filtro_estado = "";
      this.filtro_caja = "";
      this.filtro_caja = "";
      this.search = {
        cargo_serie: "",
        cliente: "",
        numero: "",
        fecha: "",
      };
      this.searchtext = "";
      this.$data.currentPage = 1;
      this.filterData();
    },
    hide: function () {
      this.$data.destroy();
    },
    refreshData(params) {
      let self = this;
      PedidosServices.fetch(params).then((res) => {
        $("#filtroModal").modal("hide");
        self.data = res.data;
      });
    },
    showModalEdit() {},
  },
};
</script>
